import { FC, ReactNode, useEffect, useState } from 'react';
import VoiceOverText, { VoiceOverLine } from './VoiceOverText';
import { cn } from 'lib/utils';

interface BPInstructionProps {
  line1: VoiceOverLine;
  line2?: VoiceOverLine | undefined;
  children?: ReactNode | undefined;
  onAnimComplete?: () => void | undefined;
  showContentImmediately?: boolean;
  twTextClasses?: string;
  twLine1TextClasses?: string;
  twLine2TextClasses?: string;
  play?: boolean;
}

const BPInstruction: FC<BPInstructionProps> = ({
  line1,
  line2,
  children,
  showContentImmediately = false,
  onAnimComplete,
  twTextClasses = 'text-[18px] leading-6 gap-[10px]',
  twLine1TextClasses = '',
  twLine2TextClasses = '',
  play = true,
}) => {
  const [showContent, setShowContent] = useState<boolean>(false);
  const [showLine2, setShowLine2] = useState<boolean>(false);

  useEffect(() => {
    if (showContentImmediately) setInterval(() => setShowContent(true), 1000);
  }, [showContentImmediately]);

  const finished = () => {
    setShowContent(true);
    if (onAnimComplete) onAnimComplete();
  };

  return (
    <div
      className={cn(
        'grid grid-rows-[auto_1fr] text-left gap-[10px] w-fit',
        children ? 'h-[full]' : 'h-[auto]'
      )}
    >
      <div
        className={cn('grid grid-flow-row pt-[9px] text-left', twTextClasses)}
      >
        <VoiceOverText
          line={line1}
          onAnimComplete={() => (line2 ? setShowLine2(true) : finished())}
          play={play}
          className={cn(line2 ? 'text-bionic-muted' : '', twLine1TextClasses)}
        />
        {line2 && (
          <VoiceOverText
            line={line2}
            onAnimComplete={finished}
            play={showLine2}
            className={twLine2TextClasses}
          />
        )}
      </div>
      {children && showContent && (
        <div className="animate-fade-in">{children}</div>
      )}
    </div>
  );
};

export default BPInstruction;
